<template>
<div>
    <Loading
        v-model:active="loading"
        :can-cancel="false"
        :widh="100"
        :height="100"
        :is-full-page="true"
        :opacity="0.7"
        color="#0dcaf0"
        background-color="#000"
    ></Loading>
    <div v-if="valid" class="wrap">
        <div class="card grid" role="region" aria-label="付款資訊卡片">
            <div class="left">
                <div class="brand-badge">
                    <img :src="audiLogo" alt="AUDI Logo" class="badge-logo" /> X
                    <img :src="evoasisLogo" alt="EVOASIS Logo" class="badge-logo" />
                </div>
                <div class="brand">
                    <div class="logo">Pay</div>
                    <div>
                        <h1 class="text-left">結帳付款</h1>
                        <p class="lead">請確認以下資訊，發票開立方式可直接編輯。</p>
                    </div>
                </div>

                <form v-if="!loading" id="payForm" novalidate>
                    <div class="row">
                        <div class="field">
                            <label for="name" class="text-left">姓名</label>
                            <input v-model="name" type="text" readonly />
                        </div>
                        <div class="field">
                            <label for="phone" class="text-left">電話</label>
                            <input v-model="phone" type="tel" readonly />
                        </div>
                    </div>

                    <div class="field">
                        <label for="email" class="text-left">Email</label>
                        <input v-model="email" type="email" readonly />
                    </div>

                    <div class="field">
                        <label for="invoiceType" class="text-left">發票開立方式</label>
                        <div class="radio-buttons">
                            <input v-model="invoiceType" type="radio" id="personal" value="個人發票">
                            <label for="personal">個人發票</label>

                            <input v-model="invoiceType" type="radio" id="company" value="公司發票">
                            <label for="company">公司發票</label>
                        </div>
                    </div>
                    <div v-if="invoiceType == '個人發票'" class="field">
                        <div class="row gap-0">
                            <div class="field" style="padding-right:0">
                                <label for="invoiceMethod" class="text-left">個人發票</label>
                                    <select 
                                        v-model="invoiceMethod" name="invoiceMethod"
                                        :class="{ 'input-error': errors.invoiceMethod }"
                                        @change="errors.invoiceMethod = null"
                                    >
                                        <option :value="undefined">請選擇</option>
                                        <option value="捐贈發票:(591) 台灣狗腳印">捐贈發票</option>
                                        <option value="手機條碼">手機條碼</option>
                                        <option value="綠界載具">綠界載具</option>
                                    </select>
                            </div>
                            <div class="field justify-content-end">
                                <template v-if="invoiceMethod == '捐贈發票:(591) 台灣狗腳印'">
                                    <input value="(591) 台灣狗腳印" type="text" readonly />
                                </template>
                                <template v-if="invoiceMethod == '手機條碼'">
                                    <input
                                        v-model="carrier"
                                        type="text"
                                        placeholder="請輸入您的手機條碼"
                                        :class="{ 'input-error': errors.carrier }"
                                        @input="errors.carrier = null"
                                    />
                                </template>
                                <template v-if="invoiceMethod == '綠界載具'">
                                    <input
                                        v-model="ecpayEmail"
                                        type="text"
                                        placeholder="請輸入您的 Email"
                                        :class="{ 'input-error': errors.ecpayEmail }"
                                        @input="errors.ecpayEmail = null"
                                    />
                                </template>
                            </div>
                        </div>
                    </div>

                    <div v-if="invoiceType == '公司發票'" class="field">
                        <label for="phone" class="text-left">公司抬頭 <span class="required">*</span></label>
                        <input
                            v-model="companyTitle"
                            type="text"
                            :class="{ 'input-error': errors.companyTitle }"
                            @input="errors.companyTitle = null"
                        />
                        <span v-if="errors.companyTitle" class="helper">{{ errors.companyTitle }}</span>
                    </div>
                    <div v-if="invoiceType == '公司發票'" class="field">
                        <label for="phone" class="text-left">公司統編 <span class="required">*</span></label>
                        <input
                            v-model="companyTaxId"
                            type="text"
                            :class="{ 'input-error': errors.companyTaxId }"
                            @input="errors.companyTaxId = null"
                        />
                        <span v-if="errors.companyTaxId" class="helper">{{ errors.companyTaxId }}</span>
                    </div>
                    <div v-if="invoiceType == '公司發票'" class="field">
                        <label for="phone" class="text-left">公司聯絡 email <span class="required">*</span></label>
                        <input
                            v-model="companyEmail"
                            type="email"
                            :class="{ 'input-error': errors.companyEmail }"
                            @input="errors.companyEmail = null"
                        />
                        <span v-if="errors.companyEmail" class="helper">{{ errors.companyEmail }}</span>
                    </div>

                    <div style="display:flex;gap:10px;align-items:center;margin-top:6px">
                        <input v-model="agree" id="agree" type="checkbox" />
                        <label for="agree" class="mb-0" style="cursor:pointer">我已確認購買內容與金額並同意交易條款</label>
                    </div>

                </form>
            </div>

            <aside v-if="!loading" class="right" aria-label="付款摘要">
                <div class="summary">
                    <div style="display:flex;justify-content:space-between;align-items:center">
                        <div>
                            <div class="muted text-left">訂單金額</div>
                            <div class="amount">NT$ 13,500 <span class="badge">含稅</span></div>
                        </div>
                        <div style="text-align:right">
                            <div class="muted">訂單編號</div>
                            <div class="small">#{{ orderNumber }}</div>
                        </div>
                    </div>

                    <div class="box">
                    <div class="muted text-left">費用明細</div>
                    <div style="display:flex;justify-content:space-between;margin-top:8px">
                        <div class="small">商品小計</div>
                        <div class="small">NT$ 12,857</div>
                    </div>
                    <div style="display:flex;justify-content:space-between;margin-top:6px">
                        <div class="small">營業稅 (5%)</div>
                        <div class="small">NT$ 643</div>
                    </div>
                    </div>
                </div>

                <div class="mt-auto d-flex align-items-center" >
                    <button class="pay-btn" id="payNow" aria-label="立即付款" @click="onPay">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M21 7L9 19l-5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        立刻付款
                    </button>
                </div>
                <div class="small text-left" style="margin-top:8px">如有任何問題，歡迎聯繫EVOASIS，將有專員為您協助。</div>
            </aside>
        </div>
    </div>
    <div v-else-if="!loading" class="wrap">
        <div class="card d-flex justify-content-center" role="region" style="min-width:100px;height:300px;">
            <h1>此付款連結已失效，如有任何問題，歡迎聯繫EVOASIS，將有專員為您協助。</h1>
        </div>
    </div>
    <footer class="small-center">服務專線：06-602-0889 • Email：help@evoasis.com.tw</footer>
</div>
</template>

<script setup>
import { ref, onBeforeMount, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import Loading from 'vue-loading-overlay'
import axios from "axios";
import moment from 'moment'
import CryptoJS from 'crypto-js';
import audiLogo from '@/assets/img/audi.svg';
import evoasisLogo from '@/assets/img/evoasis.svg';

const route = useRoute()
const loading = ref(true)
const valid = ref(false)
const orderId = ref(route.params.orderId)
const orderNumber = ref()
const name = ref()
const phone = ref()
const email = ref()
const invoiceType = ref("個人發票")
const invoiceMethod = ref("捐贈發票")
const carrier = ref()
const ecpayEmail = ref()
const companyTitle = ref()
const companyTaxId = ref() 
const companyEmail = ref()
const agree = ref(false)

onMounted(() => {
    document.title = route.meta.title;
})

onBeforeMount(async () => {
    try {
        await fetchOrderInvoice()
    } catch (error) {
        console.log(error);
    }
});

const errors = ref({})

const validate = () => {
    const e = {}

    if (invoiceType.value === '個人發票') {
        if (!invoiceMethod.value || invoiceMethod.value === undefined) {
            e.invoiceMethod = '請選擇發票方式'
        }
        if (invoiceMethod.value === '手機條碼') {
            if (!carrier.value || !carrier.value.trim()) {
                e.carrier = '手機條碼為必填'
            }
        }
        if (invoiceMethod.value === '綠界載具') {
            if (!ecpayEmail.value || !ecpayEmail.value.trim()) {
                e.ecpayEmail = 'Email 為必填'
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(ecpayEmail.value.trim())) {
                e.ecpayEmail = 'Email 格式錯誤'
            }
        }
    }

    if (invoiceType.value === '公司發票') {
        if (!companyTitle.value || !companyTitle.value.trim()) {
            e.companyTitle = '公司抬頭為必填'
        }
        if (!companyTaxId.value || !companyTaxId.value.trim()) {
            e.companyTaxId = '公司統編為必填'
        } else if (!/^\d{8}$/.test(companyTaxId.value.trim())) {
            e.companyTaxId = '統編應為 8 碼數字'
        }
        if (!companyEmail.value || !companyEmail.value.trim()) {
            e.companyEmail = '公司聯絡 Email 為必填'
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(companyEmail.value.trim())) {
            e.companyEmail = 'Email 格式錯誤'
        }
    }

    errors.value = e
    return Object.keys(e).length === 0
}

const fetchOrderInvoice = async() => {
    const { data: orderInvoiceResponse } = await axios.get(`https://api.evoasis.com.tw/portal/wix/order/audi/${orderId.value}/invoice`)
    if(orderInvoiceResponse != null) {
        valid.value = true
        orderNumber.value = orderInvoiceResponse.orderNumber
        name.value = orderInvoiceResponse.contact.name
        phone.value = orderInvoiceResponse.contact.phone
        email.value = orderInvoiceResponse.contact.email
        
        invoiceType.value = orderInvoiceResponse.invoice.invoiceType
        invoiceMethod.value = orderInvoiceResponse.invoice?.method

        carrier.value = orderInvoiceResponse.invoice?.carrier
        ecpayEmail.value = orderInvoiceResponse.invoice?.email

        companyTitle.value = orderInvoiceResponse.invoice?.companyTitle
        companyTaxId.value = orderInvoiceResponse.invoice?.companyTaxId
        companyEmail.value = orderInvoiceResponse.invoice?.companyEmail 
    }
    loading.value = false
}

const onPay = async() => {
    /* To do: 驗證手機條碼格式 */
    if (!agree.value) {
        alert("請先勾選同意條款");
        return;
    }
    if (!validate()) return;
    let eInvoiceType, CustomField2, CustomField3, CustomField4 = ""
    if(invoiceType.value == '個人發票'){
        switch(invoiceMethod.value){
            case '手機條碼':
                eInvoiceType = 1
                CustomField2 = carrier.value
                break
            case '綠界載具':
                eInvoiceType = 2
                CustomField2 = ecpayEmail.value
                //CustomField2 = 'test@cc.cc'
                break
            default:
                eInvoiceType = 0
        }
            
    }else{
        eInvoiceType = 3
        CustomField2 = companyTaxId.value
        CustomField3 = companyTitle.value
        CustomField4 = companyEmail.value
    }
    const merchantTradeNo = `Audi${moment().utcOffset(8).format('YYYYMMDDHHmmss')}`;
    const merchantTradeDate = moment().utcOffset(8).format('YYYY/MM/DD HH:mm:ss');
    const params = {
        MerchantID: process.env.VUE_APP_AUDI_ECPAY_PAYMENT_MERCHANT_ID,
        MerchantTradeNo: merchantTradeNo,
        MerchantTradeDate: merchantTradeDate,
        PaymentType: 'aio',
        TotalAmount: 13500,
        TradeDesc: 'install',
        ItemName: 'installation service fee',
        ReturnURL: `https://api.evoasis.com.tw/portal/wix/order/audi/${orderId.value}/paid`,
        ChoosePayment: 'Credit',
        EncryptType: 1,
        NeedExtraPaidInfo: 'Y',
        CustomField1: eInvoiceType,
        CustomField2,
        CustomField3,
        CustomField4
    };
    
    params.CheckMacValue = generateCheckMacValue(params, process.env.VUE_APP_AUDI_ECPAY_PAYMENT_HASH_KEY, process.env.VUE_APP_AUDI_ECPAY_PAYMENT_HASH_IV)

    let form = document.createElement('form')
    form.method = 'POST'
    form.action = process.env.VUE_APP_ECPAY_PAYMENT_URL
    form.target = '_self'

    Object.entries(params).forEach(([key, value]) => {
        const input = document.createElement('input')
        input.type = 'hidden'
        input.name = key
        input.value = value
        form.appendChild(input)
    })
    
    document.body.appendChild(form)
    form.submit()
}

const generateCheckMacValue = (params, hashKey, hashIV) => {
    // 1. Sort keys alphabetically, case-insensitive
    const sortedKeys = Object.keys(params).sort((a, b) =>
        a.localeCompare(b, 'en', { sensitivity: 'base' })
    );

    // 2. Build raw string with HashKey and HashIV
    let raw = `HashKey=${hashKey}`;
    for (const key of sortedKeys) {
        raw += `&${key}=${params[key]}`;
    }
    raw += `&HashIV=${hashIV}`;
    console.log('raw', raw)
    // 3. URL encode and apply ECPay replacements
    raw = encodeURIComponent(raw)
        .toLowerCase()
        .replace(/%20/g, '+')
        .replace(/%21/g, '!')
        .replace(/%28/g, '(')
        .replace(/%29/g, ')')
        .replace(/%2a/g, '*');

    // 4. SHA256 hash, uppercase
    return CryptoJS.SHA256(raw).toString(CryptoJS.enc.Hex).toUpperCase();
}

</script>
<style lang="scss">
:root{
    --card:#ffffff;
    --muted:#6b7280;
    --accent1:linear-gradient(135deg,#6ee7b7 0%,#3b82f6 100%);
    --shadow: 0 8px 24px rgba(43,52,69,0.08);
    --radius:16px;
    font-family: Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Noto Sans TC", "Helvetica Neue", Arial;
}
</style>
<style lang="scss" scoped>
body {
    line-height: 1.4;
}

.wrap {
    min-height: 90vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 32px 16px 18px;

    @media (max-width: 880px) {
        min-height: unset;
        align-items: flex-start;
        padding: 20px 12px 16px;
    }
}

.card {
    position: relative;
    width: 100%;
    max-width: 920px;
    background: var(--card);
    border-radius: var(--radius);
    box-shadow: var(--shadow);
    overflow: hidden;
}

.card.grid {
    display: grid;
    grid-template-columns: 1fr 380px;

    @media (max-width: 880px) {
        grid-template-columns: 1fr;
        max-width: 480px;
    }
}

.left {
    padding: 32px 36px;

    @media (max-width: 880px) {
        padding: 24px 20px;
    }
}

.brand {
    display: flex;
    gap: 12px;
}

.logo {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    background: var(--accent1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: 700;
    box-shadow: 0 6px 18px rgba(59, 130, 246, 0.18);
    flex-shrink: 0;  /* 防止被壓縮 */
}

h1 {
    font-size: 18px;
    margin: 0;
}

p.lead {
    margin: 6px 0 18px;
    color: var(--muted);
    font-size: 13px;
}

.radio-buttons {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.radio-buttons input[type="radio"] {
    display: none;
}

.radio-buttons label {
    flex: 1;
    font-size: 16px;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 10px;
    cursor: pointer;
    background: #f9f9f9;
    margin-bottom: 0;
    color: var(--bs-body-color);
    text-align: center;
}

.radio-buttons input[type="radio"]:checked + label {
    background: var(--accent1);
    color: white;
    border: none;
}

form {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.row {
    display: flex;
    gap: 12px;

    @media (max-width: 480px) {
        flex-direction: column;  /* 極小螢幕姓名/電話也垂直堆疊 */
        gap: 14px;
    }
}

.field {
    flex: 1;
    display: flex;
    flex-direction: column;
}

label {
    font-size: 14px;
    color: var(--muted);
    margin-bottom: 8px;
}

input[type=text],
input[type=email],
input[type=tel],
select,
textarea {
    padding: 12px 14px;
    border-radius: 10px;
    border: 1px solid #e6edf6;
    background: white;
    font-size: 14px;
    outline: none;
    width: 100%;
    box-sizing: border-box;
}

input[type=text]:read-only,
input[type=email]:read-only,
input[type=tel]:read-only {
    cursor: default;
    background: #fbfdff;
}

.small {
    font-size: 12px;
    color: var(--muted);
}

.right {
    background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
    padding: 28px;
    border-left: 1px dashed #eef2f7;
    display: flex;
    flex-direction: column;
    gap: 18px;

    @media (max-width: 880px) {
        border-left: none;
        border-top: 1px dashed #eef2f7;
        padding: 20px;
    }
}

.summary {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.amount {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 700;
    font-size: 20px;
}

.badge {
    background: #f1f5f9;
    color: #0f172a;
    padding: 6px;
    margin-left: 5px;
    border-radius: 5px;
    font-size: 12px;
    border: 1px solid #e6edf6;
}

.box {
    background: #ffffff;
    padding: 12px;
    border-radius: 10px;
    border: 1px solid #f0f4f8;
}

.muted {
    color: var(--muted);
    font-size: 13px;
}

.pay-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 14px;
    border-radius: 12px;
    background: var(--accent1);
    color: white;
    border: none;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 8px 20px rgba(59, 130, 246, 0.18);
    width: 100%;
}

.pay-btn:active {
    transform: translateY(1px);
}

footer.small-center {
    font-size: 12px;
    color: var(--muted);
    text-align: center;
    padding: 14px;
}

.error {
    border-color: #fca5a5;
    background: linear-gradient(180deg, #fff7f7, #fffaf9);
}

.helper {
    font-size: 12px;
    color: #ef4444;
    margin-top: 6px;
}

.text-left {
    text-align: left;
}

.brand-badge {
    padding: 6px 0 20px;
    margin-bottom: 25px;
    display: flex;
    gap: 20px;
    border-bottom: 1px dashed #eef2f7;
    align-items: center;
    z-index: 10;
}

.brand-badge::after {
    content: '';
    width: 100%;
    height: 5px;
    border-radius: 12px;
    background: var(--accent1);
}

.badge-logo {
    height: 24px;
    width: auto;
}

.input-error {
    border-color: #fca5a5 !important;
    background: #fff7f7 !important;
}

.helper {
    font-size: 12px;
    color: #ef4444;
    margin-top: 6px;
}

.required {
    color: #ef4444;
}

</style>